<template>
  <div class="platform-info-edit-wrp ft-12">
    <div v-loading="loading" class="tb-form">
      <slot name="errMsg"></slot>
      <Form
        ref="form"
        :baseItemId="form.baseItemId"
        :formSections="formSections"
        :defaultData="formData"
        @categoryChange="getUiData"
        @fieldChanged="specificationsFieldChanged"
        >
         <template v-slot:shipShelf> 
            <!-- 运费模板 -->
              <section>
                <div class="title ft-12">
                  <span>运费模板</span>
                </div>
                <div class="conf">
                  <el-form-item label="运费设置：">
                    <el-row  v-if="shopList.length > 0">
                      <el-col v-for="shop in shopList" :key="shop.id" :span="12" class="set-ship">
                        <el-image
                          :src="shop.icon"
                          style="width: 26px; height: 26px;  border-radius: 50%"
                          ></el-image>
                        <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                          <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                        </el-tooltip>
                          <span class="shop-title">{{ shop.shortTitle || shop.title}}</span>
                          <el-select 
                            v-model="shipsValue[shop.id]" 
                            placeholder="请选择运费模板"
                            :value-key="String(shop.id)"
                            clearable
                            @visible-change="changeSelect(shop.id, shop.userId)"
                            @change="shipsChanged($event, shop.id,  shop.userId)"
                            >
                            <el-option
                              v-for="ship in shipsTemplate[shop.id]"
                              :key="ship.id"
                              :label="ship.name"
                              :value="ship.id"
                              >
                            </el-option>
                          </el-select>
                      </el-col>
                    </el-row>
                    <span v-else class="no-shops">暂无平台店铺</span>
                  </el-form-item>
                </div>
              </section>
              <!-- 上架设置 -->
              <section>
                <div class="title ft-12">
                  <span>上架设置</span>
                </div>
                <div class="conf">
                  <el-form-item 
                    label="上架设置:" 
                    :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
                      <el-radio-group v-model="isOnshelf">
                          <el-radio :label="1">立即上架</el-radio>
                          <el-radio :label="2">放入草稿箱</el-radio>
                      </el-radio-group>
                  </el-form-item>
                </div>
              </section>
          </template>
        </Form>
    </div>
  </div>
</template>

<script>
import { getForm } from '@/servers/prod/center/tjb';
import Form from './components/Form/Form.vue';
import { generateSections, skuDeliveryTime } from './utils/sections';
import { form2data, html2wapHtml, wapHtml2Html, dataDefaultValue } from './utils/data' 
import {getDistributionConfig, getTTeTemplateList} from '@servers/prod/conf/index.js'

import { mapActions, mapGetters, mapState } from 'vuex';
import validateMixin from '../validateMixin';

export default {
  components: { Form },
  mixins: [validateMixin],
  provide() {
    return {
      tjbFormVm: this,
      skuDeliveryTimeOptions:  ()=> this.skuDeliveryTimeOptions
    }
  },
  props: {
    form: {
      type: Object | Array,
      default() {
        return {};
      },
    },
    changeToBase: {
      type: Function,
      default() {
        return () => {}
      }
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    form: {
      handler(v) {
        const { categoryIds } = v;
        if (categoryIds && categoryIds.length) {
          this.getUiData(categoryIds, true)
          window._tjb_cutomId = -2 // 用于一些自定义下拉框的id生成
        }
        this.self_form = v;
        this.$nextTick(() => {
          this.$refs.form.$refs.form.validate();
        })
      },
      immediate: true,
      deep: true
    },
    'tjbForm.pureType': {
      handler(newVal, oldVal) {
        const fn = (children = []) => {
          children.forEach(item => {
            if(item.name === "quantity") {
              item.component.props.disabled = (newVal != 1);
            } else if (item.children?.length) {
              fn(item.children);
            }
          });
        };

        this.formSections.forEach(section => {
          fn(section.children);
        });
      }
    },
  },
  data() {
    return {
      formKey: 'tjbForm',
      active: 2,
      self_form: {},
      rules: [],
      baseInfo: {},
      formSections: [],
      formData: {},
      loading: false,
      shopList: [],
      shipsTemplate: {}, // 运费模板列表
      shipsValue: {}, // 运费模板值
      templateConfigMap: {}, // 初始值
      isOnshelf: 1,
      skuDeliveryTimeOptions: []
    };
  },
  computed: {
    ...mapGetters(['tjbForm', 'tjbData', 'shops_defaultShopId', 'shops_getCategoryPropShopId']),
    ...mapState(['initTJbDetail']),
    formatFormSections() {
      const shipsValues = Object.values(this.shipsValue);
      const shipKeys = Object.keys(this.shipsValue)
      const formSections = _.cloneDeep(this.formSections)
      console.log('shipsValue===>', this.shipsValue, shipsValues, this.templateConfigMap);
      let needRequired = false;
      for (let i = 0; i < shipKeys.length; i++) {
        const userId = shipKeys[i]
        const shopUserId = this.shipsValue[userId];
        if (shopUserId && this.templateConfigMap[userId]?.valuation === 1) {
          needRequired = true;
          break;
        }
      }
      // console.log(needRequired, formSections)
      if (needRequired && formSections.length > 0) {
        formSections[1].children.map(item => {
          if (item.name === 'itemWeight') {
            item.rules = [{ required: true, message: '运费模板为重量模板时，重量为必填项'}]
          }
          return item;
        });
      }
      return formSections;
    }
  },
  methods: {
    ...mapActions(['initTjbForm', 'initTjbData', 'clearTjbInfo', 'clearTjbForm_PData', 'updateCatePropShopIndex', 'getInitTJbDetail']),
    // 单独更新类目属性字段UI
    async updateCatPropUI() {
      this.updateCatePropShopIndex('tjb');
      this.loading = true;
      const res = await getForm({
        shopId: this.shops_getCategoryPropShopId('tjb'),
        baseItemId: '',
        catId: this.tjbForm.categoryIds[this.tjbForm.categoryIds.length - 1]
      })
      if (!res) {
        this.loading = false;
        return
      }
      const { formSections } = generateSections(res);
      this.skuDeliveryTimeOptions = skuDeliveryTime(res);
      let newCatProp = null
      function find(item) {
        if (newCatProp) return;
        if (item.name === 'catProp') {
          newCatProp = item;
          return;
        }
        if (item.children && item.children.length) {
          item.children.forEach(find)
        }
      }
      formSections.forEach(find)
      // 若没生成新的类目属性ui则不做任何变动
      if (!newCatProp) return this.loading = false;;

      let newFormSections = [...this.formSections];
      let setted = false
      function findAndSet(item, index, parent) {
        if (setted) return;
        if (item.name === 'catProp') {
          setted = true;
          parent[index] = newCatProp
          return;
        }
        if (item.children && item.children.length) {
          item.children.forEach(findAndSet)
        }
      }
      newFormSections.forEach(findAndSet)
      this.formSections = newFormSections
      this.loading = false;
    },
    async getUiData(categoryIds, categoryNoChange) {
      this.loading = true;
      this.formSections = []
      await this.getInitTJbDetail({
        baseItemId: this.form.baseItemId,
      })
      const res = await getForm({
        shopId: this.shops_defaultShopId('tjb') || 83964,
        baseItemId: '',
        // catId: 162205,
        catId: categoryIds[categoryIds.length - 1],
      });
      if (!res) {
        this.loading = false
        return false
      }
      // 动态表单
      const { formData, formSections } = generateSections(res);
      this.skuDeliveryTimeOptions = skuDeliveryTime(res);
      this.formSections = formSections.filter(item => item.children.length);
      this.initTjbForm(formData);
      this.initTjbData(dataDefaultValue({
        ...this.form,
        wirelessDesc: wapHtml2Html(this.form.wirelessDesc || '')
      }));
      // !categoryNoChange && this.clearTbForm_PData()

      this.loading = false;
    },
     handleTemplateConfig() {
      const arr = [];
      Object.keys(this.shipsValue).forEach(key=> {
        this.shipsTemplate[key].forEach(item=> {
          if(item.id == this.shipsValue[key]){
            const channel = this.shopList.find(shop => shop.id == key)?.channel
            arr.push({
              shopId: key,
              templateId: item.id,
              templateName: item.name,
              valuation: item.valuation,
              channel
            })
          }
        })
      })
      return JSON.stringify(arr);
    },
    async valid_form() {
      return new Promise(async (resolve) => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        const refForm = this.$refs.form.$refs.form;
        if (refForm) {
          setTimeout(() => {
            refForm.validate(valid => {
              resolve(valid);
            });
          }, 300)
        } else {
          resolve(false);
        }
      });
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        let specificationsValid = null;
        const saleProp = this.$refs.form.$refs.saleProp;
        if (saleProp) {
          specificationsValid = saleProp[0].validateSpecifications();
        } else {
          specificationsValid = true;
        }
        this.specificationsValidResult = specificationsValid;
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    async method_getFormData() {
      return new Promise((resovle) => {
        if (!this.tjbForm.categoryIds.length) {
          this.$message.error('请选择商品分类')
          resovle(false)
          return;
        }
        this.validPage().then((valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resovle(false)
            return false;
          }
          let salePropData = this.$refs.form.$refs.saleProp[0].method_getData()
          if (!salePropData) {
            resovle(false)
            return false;
          }
          const [specifications, skuList, sizeGroup, isGroup] = salePropData
          let formData = form2data(this.tjbForm, this.tjbData)
              formData.specifications = specifications
              formData.skuList = skuList
              formData.sizeGroup = sizeGroup
              formData.wirelessDesc = html2wapHtml(formData.wirelessDesc)
              formData.isGroup = isGroup
              formData.shopId = this.shops_getCategoryPropShopId('tjb') || 83964
              resovle({...formData, templateConfig: this.handleTemplateConfig(), startTime: this.isOnshelf == 1 ? 0 : this.isOnshelf} )
        })
      })
      // 获取数据保存
      // return this.formData;
    },
    clear_specification() {
      this.$refs.form.$refs.saleProp[0].clear_specification()
    },
    // 处理淘特详情 templateConfig
    initTemplateConfig(templateList = []) {
      const ships = {};
      this.shopList.forEach((shop) => {
        ships[shop.id] = '';
      });
      const templateConfigMap = {};
      this.self_form.templateConfig =  this.self_form.templateConfig ? this.self_form.templateConfig : [];
      this.self_form.templateConfig.forEach(item => {
        templateConfigMap[item.shopId] = {
          templateId: item.templateId,
          templateName: item.templateName,
          valuation: item.valuation,
        };
      })
      templateList.forEach(item => {
        if(!templateConfigMap[item.shopId]){
            templateConfigMap[item.shopId] = {
            templateId: item.templateId,
            templateName: item.templateName,
            valuation: item.valuation,
          };
        }
      })
     this.templateConfigMap = templateConfigMap;
     Object.keys(templateConfigMap).forEach(key => {
       ships[key] = templateConfigMap[key].templateId
     })
     this.shipsValue = ships;
     this.initShipsTemplate(templateConfigMap);
    },

    // 处理每个店铺下拉框
    initShipsTemplate(templateConfigMap) {
      const shipsTemplate = {};
      this.shopList.forEach(shop => {
        shipsTemplate[shop.id] = []
      });
      Object.keys(templateConfigMap).forEach(key=> {
        shipsTemplate[key] = [{
          id: templateConfigMap[key].templateId || '',
          name: templateConfigMap[key].templateName || '',
          valuation: templateConfigMap[key].valuation || null,
        }]
      })
      this.shipsTemplate = shipsTemplate;
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({shopType: 'tjb'});
      const shopList = this.get_AllShops_BySource('tjb');
      // 如果是重新铺货或者已经有对应的店铺进来，直接显示对应的店铺
      if(this.rowData.isFromLog) {
        this.shopList = shopList.filter(item => item.id == this.rowData.shopId);
      }else{
        this.shopList = shopList;
      }
      // 上架设置
      if(this.self_form.startTime !== null) {
        this.isOnshelf = this.self_form.startTime === 0 ? 1 : this.self_form.startTime
      } else {
        this.isOnshelf = res?.shelfState || 1;
      }
      // 运费模板
      this.initTemplateConfig(res?.templateList || []);
    },
    // 获取模板
    async getTemplateList(userId) {
      const list = await getTTeTemplateList({userId: userId});
      if (list) {
          return list.map(ship => {
              return {
                  name: ship.name,
                  id: ship.templateId,
                  valuation: ship.valuation,
              }
          });
      }
      return [];
    },
    async changeSelect(shopId, userId) {
      const list = await this.getTemplateList(userId);
      const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
      if (idx === -1) {
          this.shipsValue[shopId] = '';
      }
      this.$set(this.shipsTemplate, shopId, list);
    },
    shipsChanged(value, shopId, userId) {
      if (!value) {
        Object.assign(this.templateConfigMap[shopId], {
          templateId: null,
          templateName: null,
          valuation: null
        });
      } else {
        const list = this.shipsTemplate[shopId];
        const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
        if (idx > -1) {
          const { valuation, name, id } = list[idx];
          Object.assign(this.templateConfigMap[shopId], {
            templateId: id,
            templateName: name,
            valuation
          });
        }
      }
    }
  },
  mounted() {
    this.getConf();
  },
  destroyed() {
    this.clearTjbInfo()
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.set-ship{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.shop-title {
  width: 130px;
  margin: 0 16px 0 10px;
  font-size: 12px;
  color: #606266;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.is-disabled {
  pointer-events: none;
  opacity: 0.6;
  * {
    pointer-events: none;
  }
}
</style>